module.exports = __webpack_public_path__ + "static/img/nav_bg.78a41e90.png";